import React from 'react'
import injectSheet from 'react-jss'
import styles from './assessment-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import CircleStatus from 'pobble-components/dist/circle-status'
import ContextMenu from './context-menu/context-menu.container'
import Tooltip from 'pobble-components/dist/tooltip'
import { BulkCheckbox } from 'pobble-components/dist/bulk-action'

const AssessmentEntry = ({
  classes,
  date,
  title,
  id,
  conclusion,
  contributors,
  link,
  pending
}) => (
  <TableRow pending={pending}>
    <Cell center>
      <BulkCheckbox id={id} />
    </Cell>
    <Cell>{date}</Cell>
    <Cell>
      <a href={link} className={classes.titleLink}>
        {title}
      </a>
    </Cell>
    <Cell center>
      {contributors ? contributors : 'No'} contributor
      {contributors > 1 ? 's' : ''}
    </Cell>
    <Cell center>
      <Tooltip
        content={
          conclusion
            ? 'This moderation file has a conclusion'
            : 'No conclusion yet'
        }>
        <CircleStatus status={conclusion} />
      </Tooltip>
    </Cell>
    <Cell right>
      <ContextMenu id={id} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(AssessmentEntry)
